import React, { useEffect, useState } from "react";
import { RULES, MULTI_CHOICE, TRANSFORMATION, TRANFORMATION_RULE_SUGESSTION_OPTIONS, RULE_EMPTY_STRING } from "../../ISRConstants";
import MathOperator from "../MathOperator/mathOperatorComponent";
import SelectOptionsView  from "../SelectOptionsView";
import RuleInputComponent from "./RuleInput";
import {
  RuleObjectStateType,
  RuleObjectType,
  RuleSuggestionOptionType,
} from "../../Pages/DefineModel/model";
import { toast } from 'Components/DesignSystem/Toast/useToast';
import {
  TTransformation,
  TConnector,
  TField,
  TFieldDataConfiguration,
  TIndexState,
  TProductCategory,
  TSubmodel,
  TUpsertISRProjectDataModelsInput,
  TFieldAdditionalData,
} from "../../Pages/DefineModel/model";
import {
  getAssociatedAttributes,
} from "../../Pages/DefineModel/ModelServices/ModalServices";
import { TResponseData } from "Services/types";
import { TAttributeChoice } from "types/Pages/ProductDelta";

type RulesSubComponentProps = {
  id: string;
  subSelectedItem: TTransformation | null;
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  setUserProjectDataModels: React.Dispatch<
    React.SetStateAction<TUpsertISRProjectDataModelsInput>
  >;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo: TIndexState;
  createISRProject:()=>void;
};

type commandType = {
  id: number;
  label: string;
  description: string;
  hasOptions: boolean;
  onClickHandler: Function;
  child: [];
  type: string;
  choiceType: string;
};

const RulesSubComponent = ({
  id,
  subSelectedItem,
  selectedItem,
  setUserProjectDataModels,
  userProjectDataModels,
  indexInfo,
  createISRProject
}: RulesSubComponentProps) => {
  const [rules, setRules] = useState<RuleObjectStateType[]>([]);
  const [ruleState, setRuleState] = useState<string | undefined>("");
  const [createRule, setCreateRule] = useState<boolean | null>(false);
  const [showMath, setShowMath] = useState<boolean>(false);
  const [dynamicCommandOption, setDynamicCommandOption] = useState<any[]>();
  const [commandOptions, setCommandOptions] = useState<RuleSuggestionOptionType[]>(
    TRANFORMATION_RULE_SUGESSTION_OPTIONS
  );
  const [showSelectOptions, setShowSelectOptions] = useState<boolean>(false);
  const [selectRef, setSelectRef] = useState<any>();
  const [inputRef, setInputRef] = useState<any>();
  const [ruleScope, setRuleScope] = useState<any>();
  const [propName, setPropName] = useState<string>("");
  const [mergeFieldList, setMergeFieldList] = useState<
    (
      | TField
      | {
          id: string | null | undefined;
          type: string;
          name: string;
          belongsToDataModel: boolean;
          dataConfiguration: TFieldDataConfiguration;
          additionalData: TFieldAdditionalData;
          rules: RuleObjectType[];
        }
    )[]
  >();
  const [ruleObj, setRuleobj] = useState<RuleObjectStateType | null>(null);
  const [ruleName, setRuleName] = useState<string>();
  const [description, setDescription] = useState<string>();
  const [attributes, setAttributes] = useState<any>();
  const [ transformation, setTransformation] = useState<TTransformation | null>();
  const [hierarchyObject, setHierarchyObject] = useState<{ subModel: string, category: string, field: string }>({ subModel: "", category: "", field: "" });


  useEffect(() => {
    let prevRules;
    const itemSelected = selectedItem as TProductCategory;
    let localTransformation: TTransformation;
    if (
      itemSelected?.data &&
      "belongsToDataModel" in itemSelected?.data &&
      itemSelected?.data?.belongsToDataModel
    ) {
      localTransformation =
        userProjectDataModels?.project.dataModels[
          indexInfo?.dataModelIndex ?? -1
        ]?.data.productCategories[indexInfo?.categoryIndex ?? -1]?.data
          ?.transformations[indexInfo?.TransformationIndex ?? -1];
      prevRules = localTransformation?.rules ?? [];
    } else {
      localTransformation =
        userProjectDataModels?.project.productCategories[
          indexInfo?.categoryOutsideDataModelIndex ?? -1
        ]?.data?.transformations[indexInfo?.TransformationIndex ?? -1];
      prevRules = localTransformation?.rules ?? [];
    }
    setTransformation(localTransformation);
    if (Array.isArray(prevRules)) {
      const ruleObj = prevRules[0];
      setRules(prevRules);
      if (ruleObj) {
        setRuleobj(ruleObj);
        setRuleState(ruleObj.ruleExp);
        setRuleName(ruleObj.name);
        setDescription(ruleObj.description);
        setRuleScope(ruleObj.ruleScope);
      } else {
        setRuleState("");
        setRuleName("");
        setDescription("");
      }
    }
    setCreateRule(false);
  }, [selectedItem, subSelectedItem]);

  useEffect(() => {
    if (ruleState && ruleState.endsWith("/")) {
      setShowMath(false);
      setDynamicCommandOption([]);
      setShowSelectOptions(true);
      setPropName("");
    } else {
      setShowSelectOptions(false);
    }
    setFocusToInput();
  }, [ruleState]);

  useEffect(() => {
    scrollToBottom();
  }, [showSelectOptions, dynamicCommandOption, createRule]);

  useEffect(() => {
    let attributesList: any = [];
    const fetchAttributesByCategory = async () => {
      try {
        const itemSelected = selectedItem as TProductCategory;
        const ids = itemSelected?.data.categories.data.map((x) => x.id);
        ids.map(async (id) => {
          const response = (await getAssociatedAttributes(
            itemSelected?.data.categories.data[0].id as string
          )) as TResponseData;
          if (!response?.errorfound) {
            let retlocalFields = response?.data?.map((command: any) => {
              return {
                id: command.id,
                label: command.name,
                description: "",
                hasOptions: false,
                child: [],
                choiceType: "Attribute",
              };
            });
            attributesList.push(...retlocalFields);
          }
        });
      } catch (e) {
        console.log("Error", e);
      }
    };
    fetchAttributesByCategory();
    setAttributes(attributesList);
  }, [selectedItem]);

  const scrollToBottom = () => {
    if (selectRef) selectRef.scrollIntoView({ behavior: "smooth" });
  };

  const setFocusToInput = () => {
    if (inputRef) inputRef.focus();
  };

  const getSubModelsList = () => {
    const localCommand = userProjectDataModels.project.dataModels.filter(
      (userProjectObject) => userProjectObject.type === "Submodel"
    );
    const retlocalCommand = localCommand.map((command) => {
      return {
        id: command.id,
        label: command.data.name,
        description: "",
        hasOptions: false,
        child: [],
        choiceType: "Submodel",
        type: command.type,
      };
    });
    return retlocalCommand;
  };

  const getSubModelsFieldsList = (id: any) => {
    let localFieldModel = userProjectDataModels?.project.dataModels.filter(
      (model) => model.id == id
    );
    let localFields = localFieldModel[0]?.data?.fields ?? [];
    let retlocalFields = localFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: "",
        hasOptions: false,
        child: [],
        choiceType: "SubmodelField",
        type: command.type,
      };
    });
    return retlocalFields;
  };

  const getSubModelsFieldsChoiceList = (id: any) => {
    let localFields =
      mergeFieldList ??
      userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]
        ?.data.fields ??
      [];
    let subModel = userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.id

    let fieldObject = localFields.filter((x) => x.id == id);
    let optionToMap;
    if (fieldObject.length > 0) {
      optionToMap = fieldObject[0];
      let retlocalFields = optionToMap?.dataConfiguration?.choices?.map(
        (command:TAttributeChoice) => {
          return {
            id: command.av_id ?? command.id,
            label: command.av_value ?? command.value,
            description: "",
            hasOptions: false,
            child: [],
            choiceType: "SubmodelFieldChoice",
            type: MULTI_CHOICE,
            field: id,
            subModel: subModel
          };
        }
      );
      return retlocalFields;
    }
    // else{
    //   let rootFields = userProjectDataModels?.project.fields.filter(x=>x.id == id)
    //   console.log(rootFields)
    //   optionToMap = rootFields[0]
    //   let retlocalFields = optionToMap?.data.dataConfiguration?.choices?.map(command => {
    //     return {
    //       id: command.av_id,
    //       label: command.av_value,
    //       description: "",
    //       hasOptions: false,
    //       child: [],
    //       choiceType: "SubmodelFieldChoice",
    //       type:MULTI_CHOICE
    //     }
    //   })
    //   return retlocalFields
    // }
  };

  const getFieldsList = () => {
    let localFields = userProjectDataModels?.project.fields ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id };
    });
    let submodelFieldList: TField[] = [];
    userProjectDataModels?.project?.dataModels?.map((subModels) => {
      submodelFieldList.push(
        ...subModels?.data?.fields?.map((y) => {
          const localObj = { ...y };
          localObj.name = `"${subModels.data.name}"."${y.name}"`;
          localObj.subModel = subModels?.id
          return localObj;
        })
      );
    });
    let mergeFields = [...newlocalFields, ...submodelFieldList];
    setMergeFieldList(mergeFields);
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: "",
        hasOptions: false,
        child: [],
        choiceType: "Field",
        type: command.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const getCategoryList = () => {
    let localFields = userProjectDataModels?.project.productCategories;
    let retlocalFields = localFields.map((command) => {
      return {
        id: command.id,
        label: command.data.name,
        description: "",
        hasOptions: false,
        child: [],
        choiceType: "Category",
        type: command.type
      };
    });
    return retlocalFields;
  };
  const getTransformationList = () => {
    let localTransformationList: TTransformation[] = [];
    (userProjectDataModels?.project?.productCategories ?? []).map((x) => {
      localTransformationList.push(...x?.data?.transformations?.map(localTranformation=>{
        const localObj = {...localTranformation}
        localObj.name = `"${x.data.name}"."${localTranformation.name}"`;
        return localObj
      }))
    });
    userProjectDataModels?.project?.dataModels?.map((subModels) => {
      subModels?.data?.productCategories?.map((category) => {
        localTransformationList.push(...category?.data?.transformations?.map(localTranformation=>{
          const localObj = {...localTranformation}
          localObj.name = `"${category.data.name}"."${localTranformation.name}"`;
          return localObj
        }));
      });
    });
    let retlocalFields = localTransformationList.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: "",
        hasOptions: false,
        child: [],
        choiceType: "Field",
        type: command.type,
      };
    });
    return retlocalFields;
  };

  const updateRules = (localRules: RuleObjectStateType[]) => {
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      const newRules: RuleObjectType[] = [...localRules];
      const itemSelected = selectedItem as TProductCategory;
      if (
        itemSelected.data &&
        "belongsToDataModel" in itemSelected.data &&
        itemSelected?.data?.belongsToDataModel
      ) {
        const dataModelToUpdate =
          newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
        if (
          dataModelToUpdate &&
          dataModelToUpdate.data &&
          dataModelToUpdate.data.productCategories[
            indexInfo.categoryIndex ?? -1
          ].data.transformations[indexInfo.TransformationIndex ?? -1]
        ) {
          dataModelToUpdate.data.productCategories[
            indexInfo.categoryIndex ?? -1
          ].data.transformations[
            indexInfo.TransformationIndex ?? -1
          ].rules = newRules;
        }
      } else {
        const fieldToUpdate =
          newDataModels.project.productCategories[
            indexInfo?.fieldOutsideDataModelIndex ?? -1
          ];
        if (fieldToUpdate && fieldToUpdate.data) {
          fieldToUpdate.data.transformations[
            indexInfo.TransformationIndex ?? -1
          ].rules = newRules;
        }
      }
      return newDataModels;
    });
     createISRProject()
  };

  const handleOptionsClick = (optionObject: commandType) => {
    const rule = ruleState && ruleState.slice(0, -1);
    switch (optionObject.id) {
      case 0:
        setDynamicCommandOption(getSubModelsList());
        setRuleState(rule);
        break;
      case 1:
        setDynamicCommandOption(getFieldsList());
        setRuleState(rule);
        break;
      case 2:
        setDynamicCommandOption(getCategoryList());
        setRuleState(rule);
        break;
      case 3:
        setDynamicCommandOption(attributes);
        setRuleState(rule);
        break;
      case 4:
        setDynamicCommandOption(getTransformationList())
        setRuleState(rule);
        break;
      case 5:
        break;
      case 6:
        break;
      case 7:
        setShowMath(true);
        setRuleState(rule);
        break;
      default:
        let localRuleState = rule + " " + optionObject.label + " ";
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
    }
  };

  const handleUpdatePropNameToRuleScope = (
    optionObject: any,
    concatString: string
  ) => {
    const id = optionObject?.id
    const type = optionObject?.type
    const submodel = optionObject?.subModel ? optionObject?.subModel : hierarchyObject?.subModel
    const field = optionObject?.field ? optionObject?.field : hierarchyObject?.field
    setRuleScope({
      ...ruleScope,
      [`${propName + concatString}`]: { id: id, type: type, subModel: submodel, field: field },
    });

    setPropName(RULE_EMPTY_STRING);
    setHierarchyObject({ subModel: '', category: '', field: '' })
  };

  const handleSubOptionsCLick = (optionObject: commandType) => {
    let localRuleState = ruleState;
    const addition = '"' + optionObject.label + '"';
    switch (optionObject.choiceType) {
      case "Submodel":
        const submodelString = addition + ".";
        localRuleState = localRuleState + submodelString;
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, subModel: optionObject?.id }
          return newObj
        })
        setPropName(submodelString);
        setDynamicCommandOption(getSubModelsFieldsList(optionObject.id));
        setRuleState(localRuleState);
        break;
      case "SubmodelField":
        localRuleState = localRuleState + addition;
        // const subModelFieldOptions = getSubModelsFieldsChoiceList(
        //   optionObject.id
        // );
        setPropName(propName + addition);
        // if (!subModelFieldOptions)
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
          handleUpdatePropNameToRuleScope(
            optionObject,
            addition
          );
        setDynamicCommandOption([]);
        setRuleState(localRuleState);
        break;
      case "Field":
        const fieldOptions = getSubModelsFieldsChoiceList(optionObject.id);
        setPropName(propName + optionObject.label);
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        if (!fieldOptions)
          handleUpdatePropNameToRuleScope(
            optionObject,
            optionObject.label
          );
        setDynamicCommandOption(fieldOptions);
        setRuleState(localRuleState + optionObject.label);
        break;
      case "SubmodelFieldChoice":
        const choiceString = "." + addition;
        localRuleState = localRuleState + choiceString;
        setPropName(propName + choiceString);
        handleUpdatePropNameToRuleScope(
          optionObject,
          choiceString
        );
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
      case "Category":
        localRuleState = localRuleState+ addition 
        setPropName(propName+localRuleState)
        setRuleState(localRuleState)
        handleUpdatePropNameToRuleScope(
          optionObject,
          addition
        );
        setDynamicCommandOption([])
            break;
      case "Attribute":
        localRuleState = localRuleState + addition;
        setPropName(propName + localRuleState);
        setRuleState(localRuleState);
        handleUpdatePropNameToRuleScope(
          optionObject,
          addition
        );
        setDynamicCommandOption([]);
        break;
      case "Transformation":
        localRuleState = localRuleState + addition;
        setPropName(propName + localRuleState);
        handleUpdatePropNameToRuleScope(
          optionObject,
          addition
          );
        setDynamicCommandOption([]);
        setRuleState(localRuleState);
        break;
      default:
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
    }
  };

  // const handleCreateClickHandler = () => {
  //   setCreateRule(!createRule);
  // };

  const onChangeHandler = (e: any, type = "parent") => {
    if (type === "child") {
      if (e.includes("Done")) {
        setShowMath(false);
        setFocusToInput();
        return;
      }
      if (e.includes("Add Field")) {
        setShowMath(false);
        setShowSelectOptions(true);
        setDynamicCommandOption([]);
        setFocusToInput();
        return;
      }
      setRuleState(e);
    } else {
      setRuleState(e.target.value);
    }
  };

  const isValidMathExpression = (expression: string) => {
    try {
      // expression = expression.slice(expression.indexOf("=") + 1, expression.length)
      // // console.log(expression)
      // const parsed = parse(expression);
      // const symbols = parsed.filter((node: any) => node.isSymbolNode);
      // // console.log(symbols)
      // const scope = new Map();
      // symbols.forEach(function (x: any) {
      //   // if(KEYWORDS.includes(x.name)) scope.set(x?.name, math.sqrt)
      //   if (!KEYWORDS.includes(x.name)) scope.set(x?.name, 10);
      // })
      // return parsed.evaluate(scope)
      const stack = [];
      const openingBrackets = ["(", "[", "{"];
      const closingBrackets = [")", "]", "}"];

      for (let i = 0; i < expression.length; i++) {
        const char = expression[i];

        if (openingBrackets.includes(char)) {
          stack.push(char);
        } else if (closingBrackets.includes(char)) {
          const correspondingOpeningBracket =
            openingBrackets[closingBrackets.indexOf(char)];

          if (
            stack.length === 0 ||
            stack.pop() !== correspondingOpeningBracket
          ) {
            return false;
          }
        }
      }

      return stack.length === 0;
    } catch (error) {
      return false;
    }
  };

  const onSaveHandler = (e: any, type: string) => {
    let localRules = [...rules];
    let message = "";
    // if (type === "Edit") {
    //   console.log("EDIT")
    //   message = "Updated Successfully"
    //   localRules = rules?.map((x) => {
    //     let newObj = {...x}
    //     if (x.id === editId) {
    //       newObj.ruleExp =ruleState
    //       newObj.ruleScope=ruleScope
    //       newObj.name = ruleName
    //       newObj.description = description
    //     }
    //     return newObj;
    //   });
    // } else {
    message = "Saved Successfully";
    const itemSelected = selectedItem as TProductCategory;

    localRules = [
      // ...rules,
      {
        ruleExp: ruleState,
        name: ruleName,
        description: description,
        type: TRANSFORMATION,
        ruleScope: ruleScope ?? {},
        dependsOn:
          (ruleScope && Object.values(ruleScope).map((x: any) => x.id)) ?? [],
        targetCategory: itemSelected.id,
        fieldName: transformation?.name,
      },
    ];
    // }
    if(ruleName){
    if (ruleState) {
      if (isValidMathExpression(ruleState)) {
        setRules(localRules);
        setCreateRule(true);
        updateRules(localRules);
        resetState();
        toast.success(message);
      } else {
        toast.warning("Please enter a valid Rule");
      }
    }
  }
  else toast.warning("Rule name is mandatory field")

  };

  const resetState = () => {
    setShowMath(false);
    setShowSelectOptions(false);
    setDynamicCommandOption([]);
    // setRuleState("")
    // setRuleScope({})
    // setRuleobj(null)
    // setRuleName("")
    // setDescription("")
  };

  const onInputChangeHandler = (e: any, type: string) => {
    if (type === "ruleName") {
      setRuleName(e.target.value);
    } else {
      setDescription(e.target.value);
    }
  };

  return (
    <div id={id} className="cart-style-dm tw-bg-white tw-mt-5">
      <div className="tw-flex tw-justify-between tw-items-center ">
        <label className="cart-title">{RULES}</label>
        {/* {!createRule ? (
          <button
            onClick={handleCreateClickHandler}
            className={`tw-w-[15%] tw-rounded  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
            // disabled={editId == null ? false : true}
          >
            <AddIcon color={"#0747A6"} />
            {CREATE}
          </button>
        ) : (
          <button
            onClick={handleCreateClickHandler}
            className={`tw-w-[15%] tw-rounded  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
          >
            CANCEL
          </button>
        )} */}
      </div>
      <label className="cart-title tw-m-2">Rule Name</label>
      <span className="tw-text-red-500">
                *
      </span>
      <input data-testid="rules-transformationrulecomponent-input-1"
        className="tw-h-8 tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0 tw-border-[1px] tw-border-solid tw-border-grey-550 tw-rounded-sm tw-ml-2"
        value={ruleName}
        onChange={(e) => onInputChangeHandler(e, "ruleName")}
        ref={(el) => setInputRef(el)}
      />
      <label className="cart-title tw-m-2">Description</label>
      <input data-testid="rules-transformationrulecomponent-input-2"
        className="tw-h-8 tw-w-[95%] tw-bg-shades-of-grey-10 tw-pl-0 tw-border-[1px] tw-border-solid tw-border-grey-550 tw-rounded-sm tw-ml-2"
        value={description}
        onChange={(e) => onInputChangeHandler(e, "description")}
        ref={(el) => setInputRef(el)}
      />
      <div ref={(el) => setSelectRef(el)}>
        <label className="cart-title tw-ml-2">Rule</label>
        <RuleInputComponent
          ruleState={ruleState}
          onChangeHandler={onChangeHandler}
          onSaveHandler={onSaveHandler}
          value={ruleObj}
          setInputRef={setInputRef}
        />
      </div>
      {showMath && (
        <MathOperator state={ruleState} handleState={onChangeHandler} />
      )}
      {showSelectOptions && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={commandOptions}
            onClickHandler={handleOptionsClick}
          />
        </div>
      )}
      {dynamicCommandOption && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={dynamicCommandOption}
            onClickHandler={handleSubOptionsCLick}
          />
        </div>
      )}
    </div>
  );
};

export default RulesSubComponent;
